import React, { useState } from "react";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface PriorityStarProps {
  priority: boolean;
  id: string;
  onPriorityChange: (id: string, priority: boolean) => void;
  starClassName?: string;
  priorityStarClassName?: string;
}

export const PriorityStar: React.FC<PriorityStarProps> = ({
  priority,
  id,
  onPriorityChange,
  starClassName,
  priorityStarClassName,
}) => {
  const [isPriority, setIsPriority] = useState(priority);

  const handleStarClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const newPriority = !isPriority;
    setIsPriority(newPriority);
    onPriorityChange(id, newPriority);
  };

  return (
    <div className="flex items-center justify-center">
      <button
        onClick={handleStarClick}
        className="p-0 border-none bg-transparent cursor-pointer hover:scale-110 transition-transform"
        aria-label={priority ? "Remove priority" : "Mark as priority"}
      >
        <Star
          className={cn(
            "h-6 w-6 transition-colors",
            starClassName,
            priority
              ? `fill-[#1B1B1B] text-[#1B1B1B] ${priorityStarClassName}`
              : "fill-transparent text-gray-300 hover:text-gray-400",
          )}
        />
      </button>
    </div>
  );
};
